"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var builder_1 = __importDefault(require("./builder"));
module.exports = builder_1.default;
//# sourceMappingURL=index.js.map